export const APP_SCREENS = [
    {
        id: "home",
        label: "Home",
        placement: "HOME_SCREEN",
        title: "Home",
        where: "Home carousel: up to two Home ads, then every logo-strip ad (same as the app).",
    },
    {
        id: "events",
        label: "Events",
        placement: "EVENT_PAGE",
        title: "Event Details",
        where: "On Event Details, ads sit above the SPONSORS tile.",
    },
    {
        id: "schedule",
        label: "Event Details",
        placement: "PROFILE_PAGE",
        title: "Event Details",
        where: "On Event Details, ads sit above the SPONSORS tile.",
    },
];

export const placementForScreen = (screenId) =>
    APP_SCREENS.find((item) => item.id === screenId)?.placement || "HOME_SCREEN";

export const screenForPlacement = (placement) => {
    if (placement === "EVENT_PAGE") {
        return "events";
    }
    if (placement === "PROFILE_PAGE") {
        return "schedule";
    }
    return "home";
};

export const draftSlotForPlacement = (placement) =>
    placement === "SPONSOR_SECTION" ? "logo" : "banner";

export const screenCopy = (screenId) =>
    APP_SCREENS.find((item) => item.id === screenId) || APP_SCREENS[0];

export const AD_DISCLOSURE = "* This is an ad";
export const ADS_TITLE_MAX = 12;

export const ellipsisAdTitle = (title = "") => {
    const trimmed = String(title).trim();
    if (!trimmed) {
        return "Ad";
    }
    if (trimmed.length <= ADS_TITLE_MAX) {
        return trimmed;
    }
    return `${trimmed.slice(0, ADS_TITLE_MAX).trimEnd()}…`;
};

export const homeCarouselAds = (ads = [], logos = []) => {
    const slides = [];
    const seen = new Set();
    [...ads, ...logos].forEach((banner) => {
        const id = banner.id || banner.bannerId || banner.imageUrl;
        if (id && seen.has(id)) {
            return;
        }
        if (id) {
            seen.add(id);
        }
        slides.push(banner);
    });
    return slides;
};
